module.exports = __webpack_public_path__ + "static/media/art-medieval-illustration-1.ac6bd329.jpg";